import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import 'bulma/css/bulma.min.css';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import { Provider } from 'react-redux';
import store from './store';
import { AuthProvider } from './TokenContext';
import { IntlProvider } from 'react-intl';
import {  locales } from './components/intl';
import ErrorBoundary from './ErrorBoundary';
import { ThemeProvider } from './ThemeContext';
import { BrowserRouter } from 'react-router-dom';
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_APP_CLIENT_ID,
  },
});

const Root = () => {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('locale') || 'en'; // Initialize locale from local storage
  });

  const changeLocale = (newLocale) => {
    setLocale(newLocale);
  };
 

  return (
    <Provider store={store}>
    <AuthProvider>
      <ThemeProvider>
        <IntlProvider locale={locale} messages={locales[locale]}>
        
          <ErrorBoundary>
          <BrowserRouter>
            <App changeLocale={changeLocale} currentLocale={locale} />
            </BrowserRouter>
          </ErrorBoundary>
          
        </IntlProvider>
      </ThemeProvider>
    </AuthProvider>
  </Provider>
  );
};

ReactDOM.render(<Root />, document.getElementById('root'));
